module.exports = __webpack_public_path__ + "img/entity_06.c4bfde29.jpg";